import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { TranslationFile } from 'i18n'
import { useLocation } from 'react-router'
import queryString from 'query-string'

import './SignPsd2.scss'
import { ApplicationDispatchContext } from 'contexts/ApplicationContext'
import { MSP_ACTIONS, MspDispatchContext } from 'components/multistep/Multistep'
import { IApplicationContext } from 'interfaces/i-application-context-props'
import BankSelector from 'components/goCardless/BankSelector'
import { IGoCardlessBankItem } from 'interfaces/i-gocardless'
import goCardlessServices from 'services/goCardlessServices'
import CircleSpinner from 'components/circle-spinner/CircleSpinner'
import ErrorBox from 'components/message-boxes/error-box/ErrorBox'

export const SignPsd2De = () => {
	const { t } = useTranslation([
		TranslationFile.Translation,
		TranslationFile.Forms,
		TranslationFile.Dropdown,
	])
	const [items, setItems] = useState<IGoCardlessBankItem[]>([])
	const location = useLocation()
	const { loanApplication }: IApplicationContext = useContext(
		ApplicationDispatchContext,
	)
	const { msp, dispatchMsp } = useContext(MspDispatchContext)

	const [selectedId, setSelectedId] = useState<string | undefined>(undefined)

	const isPsd2Completed = () => {
		return (
			(queryString.parse(location.search.toLowerCase()) ?? '')
				.psd2status === 'ok'
		)
	}

	const [completing, setCompleting] = useState<boolean>(() =>
		isPsd2Completed(),
	)
	const [completeError, setCompleteError] = useState<boolean>(false)

	const completeGoCardless = async () => {
		setCompleting(true)
		setCompleteError(false)
		try {
			const queryParams = new URLSearchParams(window.location.search)
			const response = await goCardlessServices.complete({
				applicationId: loanApplication?.applicationData?.loanNumber!,
				id: queryParams.get('ref')!,
			})
			if (response.success) {
				next()
			} else {
				setCompleteError(true)
			}
		} catch (error) {
			setCompleteError(true)
		} finally {
			setCompleting(false)
		}
	}

	useEffect(() => {
		const fetchBanks = async () => {
			try {
				const response =
					await goCardlessServices.getGoCardlessInstitutions('de')
				setItems(response)
			} catch (error) {
				console.error('Error fetching banks:', error)
			}
		}

		if (!isPsd2Completed()) {
			fetchBanks()
		} else {
			completeGoCardless()
		}
	}, [])

	const next = () => {
		dispatchMsp({
			type: MSP_ACTIONS.SET_INDEX,
			payload: {
				index: msp.index + 1,
			},
		})
	}

	return (
		<div className="sign-psd2">
			{completing ? (
				<CircleSpinner />
			) : completeError ? (
				<ErrorBox
					message={t('PSD2UpdateFailed')}
					button={
						<button
							className="btn btn-primary"
							onClick={completeGoCardless}>
							{t('TryAgain')}
						</button>
					}
				/>
			) : (
				<>
					<div className="sign-psd2-section">
						<span>{t('ConfirmIncome')}</span>
						<BankSelector
							items={items}
							selectedId={selectedId}
							onSelect={setSelectedId}></BankSelector>

						<div className="sign-psd2-button-container">
							<button
								disabled={!selectedId}
								className="btn btn-primary"
								type="button"
								key="sign-psd2-button"
								onClick={(e) => {
									e.preventDefault()
									setTimeout(async () => {
										const goCardlessLink =
											await goCardlessServices.createGoCardlessLink(
												{
													redirect:
														window.location.origin +
														'/application?psd2Status=ok',
													institutionId: selectedId!,
													userLanguage: 'de',
												},
											)
										window.location.href =
											goCardlessLink.link
									}, 400)
								}}>
								{t('SIGNPSD2')}
							</button>
						</div>
					</div>
				</>
			)}
		</div>
	)
}
